namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaAssetEsperienze = 1,
        VisualizzaProdottiClassi = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.ProdottiClassiAssetEsperienze2Editor')
    export class ProdottiClassiAssetEsperienze2Editor extends Serenity.EntityGrid<ProdottiClassiAssetEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiClassiAssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return ProdottiClassiAssetEsperienzeDialog; }
        protected getIdProperty() { return ProdottiClassiAssetEsperienzeRow.idProperty; }
        protected getInsertPermission() { return ProdottiClassiAssetEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiClassiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiClassiAssetEsperienzeService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idProdottoClasse != null || this.idAssetEsperienza != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                        //
                        var assetEsperienzePickerDialog = new AssetEsperienzePickerDialog({
                            hideAssetEsperienze: this.view.getItems().map(x => x.IdProdottoClasse)
                        });
                        //
                        assetEsperienzePickerDialog.onSuccess = (selected) => {
                            // filter already existing products
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdAssetEsperienza == x.IdAssetEsperienza));

                            for (var sel of selected) {
                                var item = <ProdottiClassiAssetEsperienzeRow>{
                                    IdProdottoClasse: this.idProdottoClasse,
                                    IdAssetEsperienza: sel.IdAssetEsperienza
                                    
                                };

                                ProdottiClassiAssetEsperienzeService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdProdottoClasseAssetEsperienza: response.EntityId,
                                            IdProdottoClasse: this.idProdottoClasse,
                                            IdAssetEsperienza: sel.IdAssetEsperienza,
                                            IdAssetEsperienzaNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };
                        //
                        assetEsperienzePickerDialog.dialogOpen();
                    }
                    if (this.ambito == AmbitoEnum.VisualizzaProdottiClassi) {

                        var prodottiClassiPickerDialog = new ProdottiClassiPickerDialog({
                            idProdottoClasse: this.idProdottoClasse,
                            hideProdottiClassi: this.view.getItems().map(x => x.IdProdottoClasse)
                        });

                        prodottiClassiPickerDialog.onSuccess = (selected) => {
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdProdottoClasse == x.IdProdottoClasse));

                            for (var sel of selected) {
                                var item = <ProdottiClassiAssetEsperienzeRow>{
                                    IdAssetEsperienza: this.idAssetEsperienza,
                                    IdProdottoClasse: sel.IdProdottoClasse,
                                    //IdProdottoClasseNome: sel.Nome
                                };

                                ProdottiClassiAssetEsperienzeService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdProdottoClasseAssetEsperienza: response.EntityId,
                                            IdAssetEsperienza: this.idAssetEsperienza,
                                            IdProdottoClasse: sel.IdProdottoClasse,
                                            IdProdottoClasseNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };

                        prodottiClassiPickerDialog.dialogOpen();
                    }
                }
            });

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        ProdottiClassiAssetEsperienzeService.Delete({
                            EntityId: item.IdProdottoClasseAssetEsperienza
                        },
                            response => {
                                this.view.deleteItem(item.IdProdottoClasseAssetEsperienza);
                                this.refresh();
                            },
                            { async: false });
                    });
                }

                if (target.hasClass("AssetEsperienza-link")) {
                    e.preventDefault();
                    //
                    new Gamification.AssetEsperienzeDialog().loadByIdAndOpenDialog(item.IdAssetEsperienza);
                }
                else if (target.hasClass("ProdottoClasse-link")) {
                    e.preventDefault();
                    //
                    new Gamification.ProdottiDialog().loadByIdAndOpenDialog(item.IdProdottoClasse);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idProdottoClasse: number;
        private _idAssetEsperienza: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == ProdottiClassiAssetEsperienzeRow.Fields.IdProdottoClasseNome);
                    columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaProdottiClassi) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == ProdottiClassiAssetEsperienzeRow.Fields.IdAssetEsperienzaNome);
                    columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
                this.setEquality(ProdottiClassiAssetEsperienzeRow.Fields.IdAssetEsperienza, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idProdottoClasse() {
            return this._idProdottoClasse;
        }

        set idProdottoClasse(value: number) {
            if (this._idProdottoClasse != value) {
                this._idProdottoClasse = value;
                this.setEquality(ProdottiClassiAssetEsperienzeRow.Fields.IdProdottoClasse, value);
                this.refresh();
            }
        }
    }
}